const premium = {
  coupon: {
    placeholder: "Add coupon",
    success: {
      title: "Success!",
      message: "Your coupon has been redeemed",
    },
    error: {
      title: "There was a problem",
      message: "Incorrect Coupon Code",
    },
    redeem: "Redeem",
    payment_one: "payment",
    payment_other: "{{ count }} payments",
    coupon_applied: "Congratulations! You will receive a {{ discount }} discount on your first {{ duration }}",
  },
  payment: {
    title: "Payment",
    subtitle: "Choose your payment preference to start enjoying your benefits",
    plan_type: "Plan type:",
    plan_price: "Plan price:",
    membership: "SEP+ Membership",
    annual_membership: "Yearly membership",
    monthly: "Monthly",
    monthly_membership: "Monthly membership",
    price: "Price",
    duration: "month",
    credit_card_number: "CC Number",
    expiry: "Exp mm/yy",
    cvv: "CVV",
    confirm_purchase: "Confirm purchase",
    failure_title: "There was a problem",
    product_name: "Premium Membership",
    or: "Or",
    pay_with_card: "Pay With Card",
    update_and_pay: "Update + Pay",
    yearly: "Yearly",
    proceed: "Proceed to payment",
  },
  past_due: {
    status_message: "Your PODERsalud subscription payment failed. Please update your payment method and check your card balance.",
    success_title: "Congratulations",
    success_message: "Your payment has been successfully processed and card information has been updated.",
  },
  not_available: "Sorry, this product is not available in your state.",
  update_payment: {
    success_title: "Congratulations",
    // TODO: We need copy for this for realz
    success_message: "Your card information has been updated.",
  },
  annual: {
    billed_annually: "Billed <strong>annually</strong>",
    billed_monthly: "Billed <strong>monthly</strong>",
    discount_percentage: "{{ discount }}% discount",
    months_free: "{{ number }} months free",
    no_discount: "No discount",
    pay_full_price: "Pay full price",
    per_month: "/ month",
    per_year: "/ year",
  },
};

export default premium;
